/**
 * Site-wide SEO constants and helpers.
 * Centralised so we never hard-code URLs or brand strings in components.
 */

export const SITE_NAME = "AI METABOLIC";
export const SITE_URL = "https://ai-metabolic.com";
export const SITE_TAGLINE_CA =
  "Entendre el teu punt de partida abans de començar.";
export const SITE_TAGLINE_ES =
  "Entender tu punto de partida antes de empezar.";

export const SITE_DESCRIPTION_CA =
  "AI Metabolic ajuda persones que volen perdre pes però no saben per on començar a entendre el seu punt de partida i què les pot estar bloquejant. Sense diagnòstics, sense pressió, sense compromís.";
export const SITE_DESCRIPTION_ES =
  "AI Metabolic ayuda a personas que quieren perder peso pero no saben por dónde empezar a entender su punto de partida y qué les puede estar bloqueando. Sin diagnósticos, sin presión, sin compromiso.";

export const DEFAULT_OG_IMAGE = `${SITE_URL}/og-default.png`;
export const TWITTER_HANDLE = "@aimetabolic";

// Author / publisher (RGPD-aligned, real name only on legal pages)
export const PUBLISHER_NAME = "AI METABOLIC";
export const PUBLISHER_LOGO = `${SITE_URL}/og-default.png`;
export const PUBLISHER_EMAIL = "hola@ai-metabolic.com";

// Topics we cover — used in Organization.knowsAbout schema (E-E-A-T signal)
export const KNOWS_ABOUT_CA = [
  "obesitat i sobrepès",
  "activació física adaptada",
  "vergonya corporal i memòria emocional",
  "punt de partida en canvis de salut",
  "recuperació de capacitat funcional",
  "hàbits sostenibles sense dietes",
];
export const KNOWS_ABOUT_ES = [
  "obesidad y sobrepeso",
  "activación física adaptada",
  "vergüenza corporal y memoria emocional",
  "punto de partida en cambios de salud",
  "recuperación de capacidad funcional",
  "hábitos sostenibles sin dietas",
];

// Map app language → canonical Open Graph locale
export const OG_LOCALE = { ca: "ca_ES", es: "es_ES" };

/**
 * Build a canonical URL for the current path. Strips trailing slash.
 */
export function canonicalUrl(path = "/") {
  const clean = path.startsWith("/") ? path : `/${path}`;
  const stripped = clean === "/" ? "/" : clean.replace(/\/$/, "");
  return `${SITE_URL}${stripped}`;
}
